import service from '../config/axios.config';
import { SUPPORTED_LANGUAGES } from './const';
import i18n from '../i18n.js';

export const getUserInfo = async() => {
  const url = '/me';

  try {
    const { data: { language, hasValidObjectiveManagementLicence } = {} } = await service.get(url);
    return { language, hasValidObjectiveManagementLicence };
  } catch (error) {
    throw error;
  }
};

export const setUserLanguage = language => {
  const availableLanguages =
      Object.values(SUPPORTED_LANGUAGES);

  if (!availableLanguages.includes(language)) {
    i18n.changeLanguage(SUPPORTED_LANGUAGES.EN);
  } else {
    i18n.changeLanguage(language);
  }
};
